import React from 'react';
import PropTypes from 'prop-types';
import './Typography.scss';
import {
  TYPOGRAPHY_VARIANTS,
  resolveTypographyClassKey,
  getTypographyDefaultComponent,
  getTypographyParagraphStyle,
} from '../../tokens/typography';

const FONT_WEIGHT_STYLE = {
  regular: 'var(--ds-font-weight-regular)',
  medium: 'var(--ds-font-weight-medium)',
  semibold: 'var(--ds-font-weight-semibold)',
  bold: 'var(--ds-font-weight-bold)',
};

const Typography = ({
  variant = 'bodyMedium',
  component,
  children,
  className = '',
  color,
  style,
  fontWeight,
  paragraph = false,
  ...props
}) => {
  const classKey = resolveTypographyClassKey(variant);
  const Component = component || getTypographyDefaultComponent(variant, classKey);

  const fontWeightStyle = fontWeight ? { fontWeight: FONT_WEIGHT_STYLE[fontWeight] } : undefined;
  const paragraphStyle = getTypographyParagraphStyle(classKey, paragraph);
  const mergedStyle = { ...paragraphStyle, ...fontWeightStyle, ...style };

  const classNames = ['ds-typography', `ds-${classKey}`, color && `ds-text-${color}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classNames} style={mergedStyle} {...props}>
      {children}
    </Component>
  );
};

Typography.propTypes = {
  variant: PropTypes.oneOf(TYPOGRAPHY_VARIANTS),
  component: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.shape({}),
  fontWeight: PropTypes.oneOf(['regular', 'medium', 'semibold', 'bold']),
  paragraph: PropTypes.bool,
};

Typography.defaultProps = {
  variant: 'bodyMedium',
  component: undefined,
  children: undefined,
  className: '',
  color: undefined,
  style: undefined,
  fontWeight: undefined,
  paragraph: false,
};

export default Typography;
